import { Col, Row } from 'antd';
import styled, { css } from 'styled-components';

export const OverviewWrapper = styled(Row).attrs({
  gutter: [16, 16],
})`
  background: var(--coolest-gray-10);
  height: 100%;
  padding: var(--layout-02) var(--layout-02) 0;
  overflow: auto;
`;
export const RowCss = css`
  > .ant-row {
    margin-bottom: var(--layout-02);
  }
`;
export const LeftArea = styled(Col).attrs({
  xl: 16,
  lg: 14,
  xs: 24,
})`
  ${RowCss};
`;
export const RightArea = styled(Col).attrs({
  xl: 8,
  lg: 10,
  xs: 24,
})`
  ${RowCss};
`;
